import React, { useEffect, useState } from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import SelectPaymentMethodModal from "../../payment/modal/SelectPaymentMethodModal"
import SelectCustomerModal from "../../common/contact/modals/SelectCustomerModal"
import {
    getOptionalItemSelection,
    getCustomerIdSelection,
    getItemQuantities, getPaymentNotes, getPaymentType,
    getMultiChoiceSelection,
    getTotalAmount, useDefaultCardOnFile, getIgnorePaymentStep,
} from "../../state/selection/selectionSelectors"
import { connect, ConnectedProps } from "react-redux"
import Proposal from "../../state/proposal/Proposal"
import { clearState } from "../../state/selection/selectionActions"
import ConfigureItemSelectionModal from "./ConfigureItemSelectionModal"
import { getPriceList } from "../../state/price-list/priceListSelectors"
import EventBus from "../../common/EventBus"
import BulkService from "../../state/bulk-operation/BulkService"
import {PRICE_LIST_OBJECT_TYPE} from "../../state/price-list/Constants"
import { setBulkOperationsStatus } from "../../state/bulk-operation/BulkOperationStatusActions"
import {STATUS_BULKS_IN_PROGRESS} from "../../state/bulk-operation/BulkOperationsStatus"

type OwnProps = {
    onHide: () => boolean
    show: boolean
    proposal: Proposal
    priceListId: string
    objectType: PRICE_LIST_OBJECT_TYPE
}


const BulkCreateModalWrapper = (props: Props) => {
    const { proposal } = props
    const [displayNumber, setDisplayNumber] = useState(1)
    const [isProcessingRequest, setIsProcessingRequest] = useState(false)
    const [bulkCreationErrorMessage, setBulkCreationErrorMessage] = useState("")

    useEffect(() => void props.clearState(), [])

    const nextModal = () => setDisplayNumber(displayNumber + 1)
    const prevModal = () => {
        if (displayNumber == 1) {
            props.onHide()
            return
        }
        setDisplayNumber(displayNumber - 1)
    }

    const onCreate = () => {
        void startBulkCreate(props, proposal, setIsProcessingRequest, setBulkCreationErrorMessage)
    }

    return (
        <>
            {displayNumber === 1 &&
                <ConfigureItemSelectionModal
                    show={displayNumber === 1}
                    onHide={props.onHide}
                    onNext={nextModal}
                    onPrev={prevModal}
                    proposal={props.proposal}
                />}

            {displayNumber === 2 &&
                <SelectCustomerModal
                    show={displayNumber === 2}
                    onHide={props.onHide}
                    onNext={nextModal}
                    onPrev={prevModal}
                />}

            {displayNumber === 3 &&
                <SelectPaymentMethodModal
                    show={displayNumber === 3}
                    objectType={props.objectType}
                    onHide={props.onHide}
                    onPrev={prevModal}
                    onCreate={onCreate}
                    currency={proposal.getCurrency()}
                    errorMessage={bulkCreationErrorMessage}
                    isProcessingRequest={isProcessingRequest}
                />}
        </>
    )
}

const startBulkCreate = async (props: Props, proposal: Proposal, setIsProcessingRequest, setBulkCreationErrorMessage) => {
    const filters = {
        "fields": ["_id"],
        "filters": {
            "_id": Array.from(props.contactIds),
        },
        "keywords": "*",
        "objects": ["contacts"],
        "sortByField": "identifier",
    }

    setIsProcessingRequest(true)
    setBulkCreationErrorMessage("")

    const res = await BulkService.CreateBulkOperation({
        operationType: "price-list-bulk-create-orders",
        filters: filters,
        metadata: {
            newOrderDto: {
                chosenOptions: props.chosenOptions,
                itemQuantities: props.itemQuantities,
                selectedChoices: props.selectedChoices,
                ignorePaymentStep: props.ignorePaymentStep,
            },
            priceListId: props.priceListId,
            proposalHash: props.proposal.getProposalHash(),
            paymentType: props.paymentType,
            paymentAmount: props.balance.toString(),
            useDefaultCardOnFile: props.useDefaultCardOnFile,
            currency: proposal.getCurrency(),
            notes: props.paymentNotes,
        },
        totalItems:Array.from(props.contactIds).length,
    })

    props.setBulkOperationsStatus(STATUS_BULKS_IN_PROGRESS)
    setIsProcessingRequest(false)

    if (!res.error) {
        EventBus.dispatch(EventBus.TopicSendSuccessNotification, {
            message: <FormattedMessage
                id="bulk.modal.operations.bulk_create_success_message"
                defaultMessage="The bulk create operation started.
                    Refresh the page to see the progress."
            />
        })
        props.clearState()
        props.onHide()
    } else {
        setBulkCreationErrorMessage(res.error.message)
    }
}

BulkCreateModalWrapper.defaultProps = {
    onHide: () => { return },
    show: false,
}


const mapState = (state, props: OwnProps) => {
    return {
        ...props,
        priceList: getPriceList(state, props.priceListId),
        balance: getTotalAmount(state),
        contactIds: getCustomerIdSelection(state),
        numberOfCustomers: getCustomerIdSelection(state).size,
        itemQuantities: getItemQuantities(state),
        selectedChoices: getMultiChoiceSelection(state),
        chosenOptions: getOptionalItemSelection(state),
        paymentType: getPaymentType(state),
        useDefaultCardOnFile: useDefaultCardOnFile(state),
        paymentNotes: getPaymentNotes(state),
        ignorePaymentStep: getIgnorePaymentStep(state),
    }
}
const mapDispatch = {
    clearState,
    setBulkOperationsStatus
}

const connector = connect(mapState, mapDispatch)
type Props = ConnectedProps<typeof connector>
export default connector(injectIntl(BulkCreateModalWrapper))


// WEBPACK FOOTER //
// ./src/price-list/modal/BulkCreateModalWrapper.tsx